export const LIVE_NOTIFICATION_EVENT = 'acompanha:live-notification';

export const LIVE_NOTIFICATION_KINDS = {
    JOB_INTEGRATION_CHANGED: 'job_integration_changed',
};

export function emitLiveNotification(detail) {
    window.dispatchEvent(new CustomEvent(LIVE_NOTIFICATION_EVENT, { detail }));
}

export function subscribeLiveNotifications(handler) {
    const listener = (event) => handler(event.detail);
    window.addEventListener(LIVE_NOTIFICATION_EVENT, listener);
    return () => window.removeEventListener(LIVE_NOTIFICATION_EVENT, listener);
}

export function isJobIntegrationLiveNotification(detail) {
    return detail?.kind === LIVE_NOTIFICATION_KINDS.JOB_INTEGRATION_CHANGED;
}
